<template>
  <main
    id="stock"
    class="page-container stock-index"
    v-if="$route.path === '/home/stock'"
  >
    <section class="cards-grid-stock">
      <router-link
        to="/home/stock/tiles"
        class="card-stock"
        aria-label="Piastrelle"
      >
        <span class="icon-wrap">
          <img src="@/assets/tile.png" alt="" />
        </span>
        <span class="label">Piastrelle</span>
      </router-link>

      <router-link
        to="/home/stock/sanitary"
        class="card-stock"
        aria-label="Sanitari"
      >
        <span class="icon-wrap">
          <img src="@/assets/sanitari.png" alt="" />
        </span>
        <span class="label">Sanitari</span>
      </router-link>
    </section>
  </main>
  <router-view />
</template>

<script>
export default {
  name: "TilesSanitaryware",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style src="@/css/HomePage.css"></style>
